import { useState } from "react"

export const RequestedPropertyListState = () => {
	const [rqstdLstng, setRqstdLstng] = useState({
        list: [],
        loader: true,
        rqstdLstngInftScroll: true,
        rqstdLstngIsLoading: false,
        rqstdLstngCooldown: false,
        rqstdLstngHasMore: true,
        rqstdLstngLastId: 0,
    })
	const [types, setTypes] = useState({
        propertyTypes: [],
        propertySubTypes: [],
        allPropertySubTypes: [],
        indoorFacilities: [],
        outdoorFacilities: [],
        checkListItems: [],
    })
	const [confirmation, setConfirmation] = useState({
        isIndoorFacOpen: false,
        indoorLoader: false,
        isOutdoorFacOpen: false,
        outdoorLoader: false,
        publishConfirmation: false,
        hasInvalidInputs: false,
        loader: false,
        statusConfirmation: false,
        statusLoader: false,
        listUpdatingLoader: false,
        isListUpdated: false,
        soldConfirmation: false,
        soldUpdatingLoader: false,
        isSoldUpdated: false,
    });
	const [status, setStatus] = useState({
        statusId: "",
        statusData: "",
        isStatusUpdated: false,
    })
	const [mainInfrmtn, setMainInfrmtn] = useState({
        listingTitle: { value: "", stat: false, msg: "Listing title is required" },
        description: "",
        ownerType: { value: 1, stat: false, msg: "Owner type is required" },
        offerType: { value: 1, stat: false, msg: "Offer type is required" },
        propertyType: { value: 1, stat: false, msg: "Property type is required" },
        subType: { value: 1, stat: false, msg: "Sub-type is required" },
        condominiumName: "",
        subdivisionName: "",
        buildingName: "",
        unitNoFloorNo: "",
        blockLotUnitFloorNo: "",
        bedroom: "",
        bathroom: "",
        floorArea: "",
        landSize: "",
        forClosure: 0,
        preSelling: 0,
        price: { value: "", stat: false, msg: "Price is required!"},
        monthly: { value: "", stat: false, msg: "Monthly price is required!"},
        yearly: { value: "", stat: false, msg: "Yearly price is required!"},
        showPrice: 0, 
        availableFrom: { value: "", stat: false, msg: "Available date is required!"}, 
        property_seller_information: { contactPerson: { value: "", stat: false, msg: "Contact person is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Mobile number is required!" } },
    })
	const [dataLocations, setDataLocations] = useState({
        provinces: [],
        cities: [],
        barangays: [],
    });
	const [otherInfrmtn, setOtherInfrmtn] = useState({
        listing_contact_id: "",
        lastName: { value: "", stat: false, msg: "Last Name is required!" },
        firstName: { value: "", stat: false, msg: "First Name is required!" },
        mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
        email: { value: "", stat: false, msg: "Invalid Email!" },
        province: { value: "", stat: false, msg: "Province is required!" },
        city: { value: "", stat: false, msg: "City is required!" },
        barangay: { value: "", stat: false, msg: "Barangay is required!" },
        streetNumber: "",
        indoorFacilities: { value: [], stat: false, msg: "Select atleast 1 indoor facilities"},
        outdoorFacilities: { value: [], stat: false, msg: "Select atleast 1 outdoor facilities"},
        isAgreedToPay: { value: 0, stat: false, msg: "This agreement is required!" },
        youtubeLink: { value: "", stat: false, msg: "Please enter a proper youtube link!" },
        propertyCoverPhoto: { value: "", stat: false, msg: "Cover photo is required!", objectImg: "", b64Img: "" },
        morePhotos: { value: [], stat: false, msg: "More photos are required!", b64Imgs: [], imgProperties: [] },
        photos: [],
        checkList: [],
        contact_details_for_buyers: { firstName: { value: "", stat: false, msg: "First name is required!" }, lastName: { value: "", stat: false, msg: "Last name is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Contact number is required!" } }, 
    })
	const dfltMainInfrmtn = {
        listingTitle: { value: "", stat: false, msg: "Listing title is required" },
        description: "",
        ownerType: { value: 1, stat: false, msg: "Owner type is required" },
        offerType: { value: 1, stat: false, msg: "Offer type is required" },
        propertyType: { value: 1, stat: false, msg: "Property type is required" },
        subType: { value: 1, stat: false, msg: "Sub-type is required" },
        condominiumName: "",
        subdivisionName: "",
        buildingName: "",
        unitNoFloorNo: "",
        blockLotUnitFloorNo: "",
        bedroom: "",
        bathroom: "",
        floorArea: "",
        landSize: "",
        forClosure: 0,
        preSelling: 0,
        price: { value: "", stat: false, msg: "Price is required!"},
        monthly: { value: "", stat: false, msg: "Monthly price is required!"},
        yearly: { value: "", stat: false, msg: "Yearly price is required!"},
        showPrice: 0, 
        availableFrom: { value: "", stat: false, msg: "Available date is required!"}, 
        property_seller_information: { contactPerson: { value: "", stat: false, msg: "Contact person is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Mobile number is required!" } },
    }
    const dfltOtherInfrmtn = {
        listing_contact_id: "",
        lastName: { value: "", stat: false, msg: "Last Name is required!" },
        firstName: { value: "", stat: false, msg: "First Name is required!" },
        mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
        email: { value: "", stat: false, msg: "Invalid Email!" },
        province: { value: "", stat: false, msg: "Province is required!" },
        city: { value: "", stat: false, msg: "City is required!" },
        barangay: { value: "", stat: false, msg: "Barangay is required!" },
        streetNumber: "",
        indoorFacilities: { value: [], stat: false, msg: "Select atleast 1 indoor facilities"},
        outdoorFacilities: { value: [], stat: false, msg: "Select atleast 1 outdoor facilities"},
        isAgreedToPay: { value: 0, stat: false, msg: "This agreement is required!" },
        youtubeLink: { value: "", stat: false, msg: "Please enter a proper youtube link!" },
        propertyCoverPhoto: { value: "", stat: false, msg: "Cover photo is required!", objectImg: "", b64Img: "" },
        morePhotos: { value: [], stat: false, msg: "More photos are required!", b64Imgs: [], imgProperties: [] },
        photos: [],
        checkList: [],
        contact_details_for_buyers: { firstName: { value: "", stat: false, msg: "First name is required!" }, lastName: { value: "", stat: false, msg: "Last name is required!" }, email: { value: "", stat: false, msg: "Email is required!" }, mobileNumber: { value: "", stat: false, msg: "Contact number is required!" } }, 
    }
	const [loader, setLoader] = useState(true)

	return {
		rqstdLstng: { data: rqstdLstng, set: setRqstdLstng },
		types: { data: types, set: setTypes },
		confirmation: { data: confirmation, set: setConfirmation },
		status: { data: status, set: setStatus },
		mainInfrmtn: { data: mainInfrmtn, set: setMainInfrmtn },
		dataLocations: { data: dataLocations, set: setDataLocations },
		otherInfrmtn: { data: otherInfrmtn, set: setOtherInfrmtn },
		dfltMainInfrmtn: { data: dfltMainInfrmtn },
		dfltOtherInfrmtn: { data: dfltOtherInfrmtn },
		loader: { data: loader, set: setLoader },
	}
}
